import React from 'react';

const WandIcon = ({ width = 40, height = 40, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8445 2.58794L11.1304 1.96961L11.7487 1.68378C11.9762 1.57878 11.9762 1.25794 11.7487 1.15294L11.1304 0.867109L10.8445 0.254609C10.7395 0.0271094 10.4187 0.0271094 10.3137 0.254609L10.0279 0.872943L9.41536 1.15878C9.18786 1.26378 9.18786 1.58461 9.41536 1.68961L10.0337 1.97544L10.3195 2.58794C10.4187 2.81544 10.7454 2.81544 10.8445 2.58794Z"
      fill={color}
    />
    <path
      d="M4.13619 2.58794L4.42202 1.96961L5.04036 1.68378C5.26786 1.57878 5.26786 1.25794 5.04036 1.15294L4.42202 0.872943L4.13619 0.254609C4.03702 0.0271094 3.71036 0.0271094 3.61119 0.254609L3.32536 0.872943L2.70702 1.15878C2.47952 1.26378 2.47952 1.58461 2.70702 1.68961L3.32536 1.97544L3.61119 2.58794C3.71036 2.81544 4.03702 2.81544 4.13619 2.58794Z"
      fill={color}
    />
    <path
      d="M10.3195 6.96294L10.0337 7.58128L9.41536 7.86711C9.18786 7.97211 9.18786 8.29294 9.41536 8.39794L10.0337 8.68378L10.3195 9.30211C10.4245 9.52961 10.7454 9.52961 10.8504 9.30211L11.1362 8.68378L11.7487 8.39211C11.9762 8.28711 11.9762 7.96628 11.7487 7.86128L11.1304 7.57544L10.8445 6.95711C10.7454 6.73544 10.4187 6.73544 10.3195 6.96294Z"
      fill={color}
    />
    <path
      d="M9.24619 4.40794L7.59536 2.75711C7.36786 2.52961 7.00036 2.52961 6.77286 2.75711L0.251191 9.27294C0.0236914 9.50044 0.0236914 9.86794 0.251191 10.0954L1.90202 11.7463C2.12952 11.9738 2.49703 11.9738 2.72453 11.7463L9.24036 5.23044C9.47369 5.00878 9.47369 4.63544 9.24619 4.40794ZM7.20453 5.62711L6.38203 4.80461L7.18703 3.99961L8.00953 4.82211L7.20453 5.62711Z"
      fill={color}
    />
  </svg>
);

export default WandIcon;
